import api from './api';
import { fileNameFromDisposition, saveBlob } from '../pages/performance-report-card/config/reportCardPdf';

// AKM POC §7.1 — ortak sunucu tarafı dışa aktarma. Liste ucunun süzgeç parametreleri (sayfa HARİÇ — dosya tam veridir)
// sorgu dizesinde, { format, labels } gövdede. Yanıt:
//  - 200 dosya (Blob) → indirilir, { mode: 'file' }
//  - 202 JSON (interceptor çözer, "reportExport.queued" toast'ı orada) → { mode: 'queued', job }
//  - hata → { mode: 'failed' } (toast interceptor'da; bileşen toast ÇAĞIRMAZ)
const DROP_PARAMS = ['pageNumber', 'pageSize', 'orderBy', 'orderDir'];
// Sıralamayı dosyaya taşıyan raporlar (keepSort — ör. duyuru Okunma: ekran sırası = dosya sırası) yalnız sayfayı atar.
const PAGE_PARAMS = ['pageNumber', 'pageSize'];

const EXTENSIONS = { xlsx: 'xlsx', pdf: 'pdf', zip: 'zip' };

export function exportParams(params = {}, { keepSort = false } = {}) {
  const drop = keepSort ? PAGE_PARAMS : DROP_PARAMS;
  const out = {};
  Object.entries(params || {}).forEach(([key, value]) => {
    if (drop.includes(key)) return;
    if (value === null || value === undefined || value === '') return;
    if (Array.isArray(value) && value.length === 0) return;
    out[key] = value;
  });
  return out;
}

export async function exportReport(url, { format = 'xlsx', params = {}, labels = {}, keepSort = false } = {}) {
  try {
    const res = await api.post(url, { format, labels }, { params: exportParams(params, { keepSort }), responseType: 'blob' });
    const data = res?.data;
    if (typeof Blob !== 'undefined' && data instanceof Blob) {
      const fallback = `rapor.${EXTENSIONS[format] || format}`;
      saveBlob(data, fileNameFromDisposition(res.headers?.['content-disposition'], fallback));
      return { mode: 'file' };
    }
    if (data && data.status !== false && data.data) return { mode: 'queued', job: data.data };
    return { mode: 'failed' };
  } catch {
    return { mode: 'failed' };
  }
}

export const getMyReportExports = () => api.get('/v1/report-exports');
export const getReportExportDownload = (id) => api.get(`/v1/report-exports/${id}/download`);
